import { render, staticRenderFns } from "./Galleryv2.vue?vue&type=template&id=93ba6324&scoped=true"
import script from "./Galleryv2.vue?vue&type=script&lang=js"
export * from "./Galleryv2.vue?vue&type=script&lang=js"
import style0 from "./Galleryv2.vue?vue&type=style&index=0&id=93ba6324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ba6324",
  null
  
)

export default component.exports